import { lazy, Suspense } from 'react';
import SuspenseLoader from 'src/components/SuspenseLoader';
import TechnicalSections from './TechnicalSections';
import GuestConfirmationPage from 'src/pages/Permits/Construction/TechnicalSections/CommonSubcodeComponents/GuestConfirmationPage';

// Loader defined with suspense for lazy loading
const Loader = (Component) => {
  const WrappedComponent = (props) => (
    <Suspense fallback={<SuspenseLoader />}>
      <Component {...props} />
    </Suspense>
  );

  // Set displayName for better debugging
  WrappedComponent.displayName = `Loader(${
    Component.displayName || Component.name
  })`;

  return WrappedComponent;
};

// Importing components
const Login = Loader(lazy(() => import('src/authentications/Login')));
const Signup = Loader(lazy(() => import('src/authentications/Signup')));
const ForgotPassword = Loader(
  lazy(() => import('src/authentications/ForgotPassword'))
);
const ResetPassword = Loader(
  lazy(() => import('src/authentications/ResetPassword'))
);
const CodeVerification = Loader(
  lazy(() => import('src/authentications/CodeVerification'))
);

// Public routing component
export const publicRoutes = [
  {
    path: '/',
    element: <Login />
  },
  {
    path: '/ucc-form/:token',
    element: <TechnicalSections />
  },
  {
    path: '/signup',
    element: <Signup />
  },
  {
    path: '/forgot-password',
    element: <ForgotPassword />
  },
  {
    path: '/reset-password',
    element: <ResetPassword />
  },
  {
    path: '/verify-code',
    element: <CodeVerification />
  },
  {
    path: '/confirmation',
    element: <GuestConfirmationPage />
  }
];
